import React from 'react';
import './CSS/workshops.css';

function Workshops() {
  return (
    <div className="workshops_background workshop-grid"> 
      <aside className="testimonial_section">
        <div className="testimonial-section-title">
          <h1>Reviews</h1>
        </div>
        <div className="testimonial">
          <h3 className="testimonial_quote">"Had a fantastic night at the workshop. Dave is a very patient teacher and all round great bloke."</h3>
          <h3 className="testimonial_author">Marie, October 2019</h3>
        </div>
        <div className="testimonial">
          <h3 className="testimonial_quote">"What a fabulous day, Dave was very informative and his knowledge was great, had such a lovely time."</h3>
          <h3 className="testimonial_author">Deborah, March 2020</h3>
        </div>
      </aside>
      <main className="workshop_section">
          <h1 className="monoton_exhibition_title">Workshops</h1>
          <h3 className="homepage_text">I've been running linoprint workshops since 2018. All materials are provided.</h3>
          <h3 className="homepage_text">I also teach on a 1-1 or small group basis. </h3>
          <h3 className="homepage_text">I have Public Liability Insurance, up-to-date First Aid training and have an individual CRB certificate.</h3>
      </main>
      <aside className="upcoming-workshops">
        <h1 className="book-section-title">Book now</h1>
        <h3 className="homepage_text">Check out my upcoming workshops here:</h3>
        <form action="https://www.weststudios.co.uk/news">
          <input className="workshop-button" type="submit" value="News" />
        </form>
        <h3 className="homepage_text">Or feel free to</h3>
        <a href="https://www.tickettailor.com/events/sombreroprintmaking?fbclid=IwAR3QRnrDVStPqhmxoFP3Ci_YFKTKkVshlKAYnlAIzh7KtKdMN2euj6aDbAU" target="blank"><span className="underline small__monoton contact-button">contact me</span></a>
      </aside>
    </div>
  );
}

export default Workshops;
